import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) { return ({
    image: {
        width: '100%',
        height: '100%',
    },
}); });
export var CompanyImage = function (_a) {
    var imageUrl = _a.imageUrl;
    var classes = useStyles();
    if (!imageUrl) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement("img", { src: imageUrl, className: classes.image, alt: "\u4F1A\u793E\u753B\u50CF" });
};
//# sourceMappingURL=CompanyImage.js.map